import { Crown, Shield, Users, Star, Headphones } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";

export default function WhySerava() {
  const { t } = useLang();
  const VALUES = [
    { icon: Crown, title: t("why_curated"), description: t("why_curated_desc") },
    { icon: Star, title: t("why_beyond"), description: t("why_beyond_desc") },
    { icon: Users, title: t("why_corporate"), description: t("why_corporate_desc") },
    { icon: Shield, title: t("why_exclusive"), description: t("why_exclusive_desc") },
    { icon: Headphones, title: t("why_support"), description: t("why_support_desc") },
  ];

  return (
    <section id="why-serava" data-testid="why-serava-section" className="py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <span className="text-xs tracking-[0.3em] uppercase text-[#C5A059] font-['Outfit'] font-semibold block mb-4">{t("why_tag")}</span>
            <h2 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-light tracking-tight text-white mb-6">{t("why_title")} <span className="italic text-white/70">{t("why_title_italic")}</span></h2>
            <p className="text-white/50 font-['Outfit'] font-light leading-relaxed text-base">{t("why_desc")}</p>
          </motion.div>
          <div className="space-y-8">
            {VALUES.map((item, i) => (
              <motion.div key={item.title} initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.1 }} className="flex gap-5 group">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center border border-[#262626] bg-[#141414] group-hover:border-[#C5A059]/40 transition-colors duration-300">
                  <item.icon size={20} className="text-[#C5A059]" strokeWidth={1.5} />
                </div>
                <div>
                  <h4 className="font-['Outfit'] text-white font-medium text-base mb-1.5">{item.title}</h4>
                  <p className="text-white/40 font-['Outfit'] font-light text-sm leading-relaxed">{item.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
